import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import ShoppingCart01Icon from 'src/icons/untitled-ui/duocolor/shopping-cart-01';
import GraduationHat01Icon from 'src/icons/untitled-ui/duocolor/graduation-hat-01';
// import ReceiptCheckIcon from 'src/icons/untitled-ui/duocolor/receipt-check';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import AddReactionOutlinedIcon from '@mui/icons-material/AddReactionOutlined';

export const officerSections = (t, tokens, paths, SvgIcon, perms) => {
  const { addStudent = false } = perms;
  // Dynamic section
  const addStudentSection = 
    (addStudent) ? [
          {
            title: t(tokens.nav.studentNew),
            path: paths.accounts.studentList,
            icon: (
              <SvgIcon fontSize="small">
                <AddReactionOutlinedIcon />
              </SvgIcon>
            ),
          },
        ] : [];

  return [
    {
      items: [
        {
          title: t(tokens.nav.overview),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
        {
          title: "Đặt lịch",
          path: paths.carts.index,
          icon: (
            <SvgIcon fontSize="small">
              <ShoppingCart01Icon />
            </SvgIcon>
          ),
        },
        {
          title: "Sắp lịch",
          path: paths.orders.index,
          icon: (
            <SvgIcon fontSize="small">
              <LocalMallOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.students),
          path: paths.students.index,
          icon: (
            <SvgIcon fontSize="small">
              <Users03Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.teachers),
          path: paths.teachers.index,
          icon: (
            <SvgIcon fontSize="small">
              <AssignmentIndOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.course),
          path: paths.courses.index,
          icon: (
            <SvgIcon fontSize="small">
              <GraduationHat01Icon />
            </SvgIcon>
          ),
        },
        ...addStudentSection,
      ],
    },
  ];
};
